import {
    FullsizeImageContainer,
    FullsizeImageWrapper,
} from "#app/components/layout/GridContainer/styles";
import CloseSvg from "#app/assets/icons/close.svg";
import React, { useLayoutEffect, useState } from "react";
import clsx from "clsx";

const FullscreenImageContainer = () => {
    const [fullSizeImagePath, setFullSizeImagePath] = useState<string | null>(null);
    const [opacityEnabled, setOpacityEnabled] = useState<boolean>(false);
    const [zoomed, setZoomed] = useState<boolean>(false);

    useLayoutEffect(() => {
        window.addEventListener("keyup", (e) => {
            if (e.code && e.code === "Escape") {
                quitFullSizeView();
            }
        });
        window.addEventListener("fullsizeImageOpen", openFullsizeView);
    }, []);

    const openFullsizeView = () => {
        const imagePath: string | null = localStorage.getItem("fullsize_image_path");
        imagePath && setFullSizeImagePath(imagePath);
        setTimeout(() => setOpacityEnabled(true), 10);
    };

    const quitFullSizeView = () => {
        setOpacityEnabled(false);
        setZoomed(false);
        setTimeout(() => {
            localStorage.removeItem("fullsize_image_path");
            setFullSizeImagePath(null);
        }, 200);
    };

    return (
        <>
            {fullSizeImagePath && (
                <FullsizeImageContainer className={clsx({ [`enabled`]: opacityEnabled })}>
                    <button onClick={quitFullSizeView}>
                        <img src={CloseSvg} alt={``} />
                    </button>
                    <FullsizeImageWrapper>
                        <img
                            className={clsx({ ["zoomed"]: zoomed, ["enabled"]: opacityEnabled })}
                            onClick={() => setZoomed(!zoomed)}
                            src={fullSizeImagePath}
                            alt={``}
                        />
                    </FullsizeImageWrapper>
                </FullsizeImageContainer>
            )}
        </>
    );
};

export default FullscreenImageContainer;
